import {Translation} from "@kta20-ewo-definition/resources/lang/en";

export const it:Translation = {
    //VALIDATION
    businessevent_invalid_title:'Richiesto (massimo {1}, solo lettere e numeri)',
    businessevent_invalid_description:'Richiesto - Massimo {0}, lettere/numeri e {1}',
    ewobusinessevent_invalid_impactedareas:'Richiesto',
    ewobusinessevent_invalid_impactedmachine:'Richiesto',
    ewobusinessevent_invalid_impactedmachineoperation:'Richiesto',
    ewobusinessevent_invalid_impactedmachinesubgroup:'Richiesto',
    ewobusinessevent_invalid_rootcause:'Richiesto',
    ewobusinessevent_invalid_correctiveaction:'Richiesto',
    ewobusinessevent_invalid_calltime:'Richiesto',
    ewobusinessevent_invalid_faultytime:'Richiesto',
    ewobusinessevent_invalid_impacteddepartments:'Richiesto',
    ewobusinessevent_invalid_asset:'Richiesto (massimo {1}, solo lettere e numeri)',
    ewobusinessevent_invalid_inmachine:'Richiesto (massimo {1}, solo lettere e numeri)',
    ewobusinessevent_invalid_diagnosetime:'Richiesto - Valore maggiore o uguale a 0',
    ewobusinessevent_invalid_disassemblytime:'Richiesto - Valore maggiore o uguale a 0',
    ewobusinessevent_invalid_sparedeliverytime:'Richiesto - Valore maggiore o uguale a 0',
    ewobusinessevent_invalid_assemblytime:'Richiesto - Valore maggiore o uguale a 0',
    ewobusinessevent_invalid_startuptime:'Richiesto - Valore maggiore o uguale a 0',
    ewobusinessevent_invalid_solution:'Richiesto - Massimo {0}, lettere/numeri e {1}',

    //FILTER CONFIGURATION
    filter_title: 'Filtra per',
    filter_confirmation_label: 'ok',
    filter_cancel_label: 'annulla',
    filter_ewo_description: 'Descrizione',
    filter_ewo_event_code: 'Titolo',
    filter_ewo_creation_date: 'Data di apertura',
    filter_ewo_business_impact: 'Risolto / Non Risolto',
    filter_ewo_impacted_areas: 'Area impattata',
    filter_ewo_impacted_machine: 'Macchina impattata',
    reducer_label: 'Stato',

    start_up_ending:'Termine Avvio',
    downtime:'Inattività',
    waiting_time:'Tempo di Attesa',
    creation_user_full_name:'Creata da *',
    event_code:'Codice',
    ewo_reporting:'Reporting EWO',
    search: 'Cerca in ',
    title: 'Titolo *',
    impacted_area: 'Area Impattata *',
    impacted_machine: 'Macchina *',
    impacted_operation: 'Operazione *',
    impacted_subgroup: 'Sottogruppo *',
    impacted_machine_component: 'Componente',
    impacted_departments: 'Reparti Impattati *',
    root_cause: 'Causa *',
    corrective_action: 'Azione eseguita *',
    ewo_details: 'Dettaglio EWO',
    new_ewo: 'Nuovo EWO',
    save: 'Salva',
    call_time: 'Ora chiamata *',
    faulty_time: 'Ora inizio guasto *',
    diagnose_time: 'Tempo di diagnosi (minuti) *',
    minutes: 'minuti:',
    disassembly_time: 'Tempo di disassemblamento (minuti) *',
    spare_delivery_time: 'Tempo arrivo ricambio (minuti) *',
    assembly_time: 'Tempo di assemblamento (minuti) *',
    start_up_time: 'Tempo di startup (minuti) *',
    may_have_qa_impact: 'May have QA Impact',
    business_impact: 'Risolto?',
    description: 'Descrizione *',
    close: 'Chiudi',
    input_description: 'Digita la descrizione...',
    please_fill_all_required_fields: 'Compila le voci richieste (*)',
    solution: 'Prevenzione problema *',
    input_solution: 'Digita la soluzione...',
    okay: 'OK',
    refresh: 'Refresh',
    take_on_charge_the_request: 'Prendo in carico la richiesta...',
    months: 'Gen, Feb, Mar, Apr, Mag, Giu, Lug, Ago, Set, Ott, Nov, Dic',
    stateMap:{
        'OPN': 'Aperto',
        'CLD': 'Chiuso'
    },
    areasMap:{
        'RED':'Centro Ricerche',
        'IMPI':'Impianti',
        'SOFF':'Soffiaggio',
        'PRIN':'Presse iniezione',
        'STRZ':'Stampaggio rotazionale',
        'FIIN':'Finiture iniezione',
        'ROBO':'Robot',
        'FIRO':'Finiture rotazionale',
        'FISO':'Finiture soffiaggio'
    },
    machinesMap:{
        'ROTOSH':'Rotoplastic shuttle',
        'IPE250':'IPE 2500',
        'EQUIC':'Equlibratrice Cemb',
        'ROTO25':'Rotoplastic 2500',
        'PORT':'Portoni',
        'CARROP':'Carroponte',
        'PO35N':'Polivinil 3500 NEW',
        'NAW70524':'el.sy M157 NAW70524',
        'NAW70647':'el.sy M189 NAW70647',
        'NAV50034':'GS013 NAV 50034',
        'VA35N':'Vasca Polivnil 3500 new',
        //IMPI area
        'UFFI':'Uffici',
        'VIBRA':'Camera Test a Vibrazione e Fatica ',
        '3DSTRATA':'Stampante 3d Stratasys',
        'LABFLU':'Laboratorio Fluidinamico ',
        'BLOWER':'Blower Chamber',
        'CLIMACS':'Cella Climatica  ACS',
        'SERMAC':'Forno Sermac',
        'CLIMCH':'Cella Climatica  Challenge ',
        'TERMO':'Camera Termostatica ',
        'G751':'Compressore ga75 n°1',
        'G752':'Compressore ga75 n°2',
        'CVSD':'Compressore ga75 vsd',
        'GA55':'Compressore ga55',
        'GSVD':'Compressore ga55 vsd',
        'TOOP':'Torri evaporative',
        'CAST':'Caldaia stabilimento',
        'CAUF':'Caldaia uffici palazzina',
        'IMMA':'Impianto del materiale',
        'ADDO':'Addolcitore',
        'POZZ':'Pozzo',
        'CRPT':'Carroponti',
        'GRBA':'Gru a bandiera',
        'GRAM':'Gruppi di aspirazione materiale',

        //INIZ area
        'P247':'P247',
        'P231':'P231',
        'P503':'P503',
        'P504':'P504',
        'P230':'P230',
        'P218':'P218',
        'P220':'P220',
        'P225':'P225',
        'P248':'P248',
        'ENGE':'ENGEL',

        //SOFF area
        'P323':'P323',
        'P327':'P327',
        'P325':'P325',
        'P328':'P328',
        'P324':'P324',
        'P329':'P329',
        'UM20':'UMA 20',
        'CRPN':'Crane',

        //STRZ area
        'CA30':'Caccia 3000',
        'CA22':'Caccia 2200',
        'PO23':'Polivinil 2300',
        'PO35':'Polivinil 3500',
        'PARN':'Paranco',

        //FIIN area
        'AVDA':'Avvitatura daily',
        'RODA':'Rotofrizione daily',
        'EUMO':'Euromodel',
        '12X':'12X',
        '22X':'22X',
        '23x':'23x',
        '24x':'24x',
        '29x':'29x',
        '33x':'33x',
        'GS4U':'GS4 urea',
        'G14U':'GS014 urea',
        'COVA':'Collaudo vaschetta',
        'BRVE':'Branson vecchia',
        'BRNU':'Branson nuova',
        'COCO':'Conformatura coppa',
        'ATCO':'Avvitatore tappo coppa',
        'DICO':'Dimensionale coppa',
        'PTCO':'Prova tenuta coppa',
        'PTSU':'Prova tenuta succhieruola',
        'IMCO':'Imballaggio coppa',

        //ROBO
        'ROB1':'Robot 1',
        'ROB2':'Robot 2',
        'ROB3':'Robot 3',
        'SASN':'Saldatrice snorkel',
        'SASV':'Saldatrice snorkel vecchio',
        'BELO':'Belotti',

        //FIRO
        'VA22':'Vasca collaudo caccia 2200',
        'VA35':'Vasca  collaudo polivnil 3500',
        'VCBV':'Vasca collaudo banchi  vecchia',
        'VCBN':'Vasca collaudo banchi  nuova',
        'MLAP':'Macchina di lavaggio piccola',
        'MLAG':'Macchina di lavaggio grande',
        'BFIM':'Banchi finitura manuali',
        'BFIP':'Banchi di finitura con posaggio',

        //FISO
        'GS1':'GS1',
        'GS2':'GS2',
        'GS3':'GS3',
        'GS4':'GS4',
        'GS5':'GS5',
        'GS6':'GS6',
        'MOVE':'Modulare vecchia',
        'MONU':'Modulare nuova',
        'TAFA':'Taglierina famat',
        'TN37':'Taglierina NAV50037',
        'TN08':'Taglierina NAW5008',
        'AVRI':'Avvitatore RIMA',
        'ULHE':'Ultrasuoni Herman',
        'FTFB':'Finitura tfb',
        'MTFB':'Macchina collaudo tfb',
        'CATE':'Caterpillar'
    },
    operationsMap:{
        'EQUI':'Equilibratura',
        'PROV':'Prove',
        //IMPI area
        'SERV':"Servizi",

        //SUFF, PRIN, STRZ area
        'STPG':'Printing',

        //FIIN, ROBO area
        'COLL':'Collaudo',
        'SALD':'Saldatura',
        'TAGL':'Taglio',
        'ASMB':'Assemblaggio',
        'FORA':'Foratura',
        'AVVI':'Avvitatura',

        //FIRO
        'CONT':'Controllo',

        //FISO
        'ASSE':'Assemblaggio'
    },
    subgroupsMap:{
        'ALBE':'Albero',
        'TRAPA':'Trapani',
        'RIVE':'Rivetttatrice',
        'QUAE':'Quadro elettrico',
        'CARROP':'Carroponte',
        'PORT':'Porta',
        'RESIS':'Resistenza',
        'VENTI':'Ventilatore',
        'SICUR':'Sicurezze',
        'POMP':'Pompe',
        'CLIMA':'Climatizzatore',
        'MOTOR':'Motoriduttore',
        'FUNI':'Funi',
        'PULSA':'Pulsantiera',
        'PANOP':'Panello Operatore',
        'CALDA':'Caldaie',
        'MOBILI':'Mobili',
        'NEON':'Neon',
        //IMPI area
        'ESSI':'Essicatori',
        'DEUM':'Deumidificatori',
        'SILO':'Silos',
        'TUBI':'Tubi',
        'VALV':'Valvole',

        //PRIN area
        'CNID':'Centralina idraulica',
        'MNSC':'Manipolatore di scarico',
        'SATL':'Satellite',
        'GRCH':'Gruppo di chiusura',
        'GRIN':'Gruppo di iniezione',
        'CARR':'Carro',
        'GINO':'Ginocchiera',
        'GRLU':'Gruppo lubrifica',
        'STMP':'Stampo',
        'RIMA':'Ricevitore materiale',
        'CIID':'Circuito idraulic',
        'CIPN':'Circuito pneumatico',
        'CIEL':'Circuito elettrico',
        'CIAC':'Circuito acqua',
        'SICU':'Sicurezze',
        'RISC':'Riscaldamento',
        'COST':'Condizionamento stampo',
        'PNOP':'Pannello operatore',

        //SUFF area
        'TSES':'Testa di estrusione',
        'ESTA':'Estrusore A',
        'ESTB':'Estrusore B',
        'TAVA':'Tavola A',
        'TAVB':'Tavola B',
        'TAVO':'tavola',
        'CIST':'Chiusura stampo',
        'CHIA':'Chiusura stampo  A',
        'CHIB':'Chiusura stampo  B',
        'ROBO':'Robot',
        'PNSS':'Pinza ssw',
        'QASO':'Quadro eletrico su soppalco',
        'QAEL':'Quadro elettrico',
        'CRID':'Idraulico',
        'CREL':'Circuito elettrico',
        'CRAC':'Circuito acqua',
        'PULS':'Pulsantiera',
        'NASA':'Trasportatore A',
        'NASB':'Trasportatore B',
        'NSTR':'Trasportatore',

        //STRZ area
        'CAR1':'Carrello 1',
        'CAR2':'Carrello 2',
        'CAR3':'Carrello 3',
        'CAR4':'Carrello 4',
        'TES1':'Testa carrello 1',
        'TES2':'Testa carrello 2',
        'TES3':'Testa carrello 3',
        'TES4':'Testa carrello 4',
        'FORN':'Forno',
        'BRUC':'Bruciatore',
        'VEFO':'Ventola forno',
        'VEEF':'Ventola estrazione fumi',
        'POFO':'Porte forno',
        'VERA':'Ventola raffreddamento',
        'VEER':'Ventola estrazione raffreddamento',
        'PORA':'Porta raffreddamento',
        'QUEL':'Quadro elettrico',
        'IMAC':'Impianto acqua',
        'PEDA':'Pedana',

        //FIIN area
        'CEID':'Centralina idrulica',
        'POSA':'Posaggio',
        'CANC':'Cancello',
        'CABI':'Cabina',
        'GRSA':'Gruppo salita',
        'GRDI':'Gruppo discesa',
        'PARA':'Parametri',
        'LACA':'Lama calda',
        'CIRV':'Circuito del vuoto',
        'TEVI':'Testa vibrante',
        'AVV1':'Avvitatore 1',
        'AVV2':'Avvitatore 2',
        'MAET':'Manipolatore etichetta',
        'SPVI':'Sparovite',
        'VIBR':'Vibratore',

        //ROBO
        'TARO':'Tavola rotante',
        'TESA':'Testa di saldatura',
        'MATA':'Mandrino di taglio',
        'NATR':'Nastro trasportatore',
        'CIVU':'Circuito vuoto',
        'ASMA':'Asse macchina',
        'PAOP':'Pannello operatore',

        //FIRO
        'BILA':'Bilancia',

        //FISO
        'SPIN':'spine',
        'IMPN':'impianto pneumatico',
        'CAFN':'cabina fnitura',

        'STAM':'Stampo'
    },

    causesMap:{
        'MCBA':'Mancanza condizioni di base',
        'MAMZ':'Mancanza manutenzione',
        'MOCO':'Mancata osservanza condizioni operative',
        'DEPR':'Debolezza di progetto',
        'INES':'Influenza esterna',
        'RIEA':'Ricambi inadeguati, eventi accidentali'
    },
    correctiveMap:{
        'REGO':'Regolazione',
        'SOST':'Sostituzione',
        'PULI':'Pulizia',
        'INGR':'Ingrassaggio',
        'REVI':'Revisione'
    },
    departmentsMap:{
        'PROD':'Produzione',
        'MTZ':'Manutenzione'
    },
    downloading_file: `Scarico il file...`,
    reset_filter:'Reset Filtro',
    welcome_in_cornaglia:'Benvenuti in Cornaglia!',
    knowledge_base:'Knowledge Base'
};
